import { Injectable } from '@angular/core';
import { PatVisitStaff } from '../../inpatient/inpatient-reservation/inpatient-reservation.service';
import { RegPatService } from '../../pricing/reg-pat-service/reg-pat-service';
import { InPatientParms } from '../../shared';
import { CONFIG } from '../../shared/config';
import { HttpGeneralService } from '../../shared/http-general.service';
import { IRegPatServiceDevices } from '../emr-medical-sheet/emr-physiotherapy-sheet.service';

const sessionUrl = CONFIG.baseUrls.scheduling;
const inpatientStaffUrl = CONFIG.baseUrls.inpatientreservation;
const emrSheetsUrl = CONFIG.baseUrls.emrSheets;

@Injectable({
  providedIn: 'root'
})
export class PatientSessionDataService {

  constructor(private _http: HttpGeneralService) { }

  getSessionData(parms: RegPatService) {
    return this._http.add(parms, `${sessionUrl}/GetPatientSessionData`);
  }

  addInpatientStaff(inpatientreservation: PatVisitStaff[]) {
    return this._http.add(inpatientreservation, `${inpatientStaffUrl}/addInpatientStaff`)
  }

  updateInpatientReservation(inPatientParms: InPatientParms) {
    return this._http.add(inPatientParms, `${inpatientStaffUrl}/updateInpatientReservation`);
  }

  deleteInPatientStaff(id: number) {
    return this._http.delete(id, `${inpatientStaffUrl}/deleteInPatientStaff`)
  }

  //for RegpatServiceDevices datatable
  addRegpatServiceDevices(data: IRegPatServiceDevices[]) {
    return this._http.add(data, `${emrSheetsUrl}/AddRegpatServiceDevices`)
  }

  getRegpatServiceDevicesLoad(data: IRegPatServiceDevices) {
    return this._http.post(data, `${emrSheetsUrl}/GetRegpatServiceDevicesLoad`)
  }

  deleteRegpatServiceDevices(data: IRegPatServiceDevices) {
    return this._http.delete(data.serial, `${emrSheetsUrl}/DeleteRegpatServiceDevices`)
  }

}
